// Draws the personal "I have entered the light" card in the browser. The light
// pattern is seeded by the instant of entry; nothing about the person is drawn.

function mulberry32(seed) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const GOLD = [132, 223, 244];
const WARM = [183, 199, 214];
const SILVER = [234, 234, 234];
const rgba = ([r, g, b], a) => `rgba(${r},${g},${b},${a})`;

function bloom(ctx, x, y, r, tint, alpha) {
  const g = ctx.createRadialGradient(x, y, 0, x, y, r);
  g.addColorStop(0, rgba(tint, alpha));
  g.addColorStop(0.35, rgba(tint, alpha * 0.4));
  g.addColorStop(1, rgba(tint, 0));
  ctx.fillStyle = g;
  ctx.fillRect(x - r, y - r, r * 2, r * 2);
}

function paintLight(ctx, w, h, rnd) {
  ctx.fillStyle = "#030305";
  ctx.fillRect(0, 0, w, h);
  ctx.globalCompositeOperation = "lighter";
  const m = Math.min(w, h);
  const cx = w / 2;
  const cy = h * 0.42;

  const n = 5 + Math.floor(rnd() * 4);
  for (let i = 0; i < n; i += 1) {
    const ang = rnd() * Math.PI * 2;
    const dist = rnd() * m * 0.34;
    const tint = rnd() < 0.62 ? WARM : rnd() < 0.5 ? GOLD : SILVER;
    bloom(ctx, cx + Math.cos(ang) * dist, cy + Math.sin(ang) * dist * 0.85, m * (0.16 + rnd() * 0.3), tint, 0.08 + rnd() * 0.14);
  }
  bloom(ctx, cx + (rnd() - 0.5) * m * 0.2, cy + (rnd() - 0.5) * m * 0.16, m * 0.1, WARM, 0.42);

  ctx.lineCap = "round";
  const strands = 3 + Math.floor(rnd() * 3);
  for (let i = 0; i < strands; i += 1) {
    const x0 = cx + (rnd() - 0.5) * m * 0.9;
    const y0 = cy + (rnd() - 0.5) * m * 0.7;
    ctx.beginPath();
    ctx.moveTo(x0, y0);
    ctx.bezierCurveTo(
      x0 + (rnd() - 0.5) * m * 0.7, y0 + (rnd() - 0.5) * m * 0.5,
      cx + (rnd() - 0.5) * m * 0.7, cy + (rnd() - 0.5) * m * 0.5,
      cx + (rnd() - 0.5) * m * 0.9, cy + (rnd() - 0.5) * m * 0.7
    );
    ctx.strokeStyle = rgba(rnd() < 0.7 ? GOLD : SILVER, 0.18 + rnd() * 0.24);
    ctx.lineWidth = 0.8 + rnd() * 1.6;
    ctx.shadowColor = rgba(GOLD, 0.5);
    ctx.shadowBlur = m * 0.02;
    ctx.stroke();
  }
  ctx.shadowBlur = 0;

  ctx.fillStyle = rgba(SILVER, 0.035);
  for (let i = 0; i < 260; i += 1) {
    const r = 0.4 + rnd() * 1.3;
    ctx.beginPath();
    ctx.arc(rnd() * w, rnd() * h, r, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.globalCompositeOperation = "source-over";

  const v = ctx.createRadialGradient(cx, h / 2, m * 0.25, cx, h / 2, Math.max(w, h) * 0.75);
  v.addColorStop(0, "rgba(3, 3, 5,0)");
  v.addColorStop(1, "rgba(3, 3, 5,0.85)");
  ctx.fillStyle = v;
  ctx.fillRect(0, 0, w, h);
}

function tracked(ctx, text, x, y, spacing) {
  const width = [...text].reduce((acc, ch) => acc + ctx.measureText(ch).width + spacing, -spacing);
  let cx = x - width / 2;
  ctx.textAlign = "left";
  for (const ch of text) {
    ctx.fillText(ch, cx, y);
    cx += ctx.measureText(ch).width + spacing;
  }
}

function paintWords(ctx, w, h, dateLabel, portrait) {
  const s = portrait ? w / 1080 : w / 1200;
  const cx = w / 2;
  const top = portrait ? h * 0.66 : h * 0.6;
  ctx.textBaseline = "alphabetic";

  ctx.fillStyle = rgba(GOLD, 0.7);
  ctx.shadowColor = rgba(GOLD, 0.35);
  ctx.shadowBlur = 14 * s;
  ctx.fillRect(cx - 48 * s, top, 96 * s, 1.5 * s);
  ctx.shadowBlur = 0;

  ctx.fillStyle = rgba(SILVER, 0.96);
  ctx.textAlign = "center";
  ctx.font = `300 ${(portrait ? 58 : 50) * s}px "Geist Variable", Arial, sans-serif`;
  ctx.fillText("I have entered the light", cx, top + (portrait ? 110 : 88) * s);

  ctx.fillStyle = rgba(GOLD, 0.92);
  ctx.font = `300 ${(portrait ? 22 : 20) * s}px "Geist Variable", Arial, sans-serif`;
  tracked(ctx, "PRISM PIXEL\u2122", cx, top + (portrait ? 172 : 138) * s, 7 * s);

  ctx.fillStyle = rgba(SILVER, 0.62);
  ctx.textAlign = "center";
  ctx.font = `300 ${(portrait ? 24 : 21) * s}px Inter, "Inter Fallback", Arial, sans-serif`;
  ctx.fillText(dateLabel, cx, top + (portrait ? 232 : 186) * s);

  ctx.fillStyle = rgba(SILVER, 0.4);
  ctx.font = `300 ${(portrait ? 18 : 16) * s}px Inter, "Inter Fallback", Arial, sans-serif`;
  tracked(ctx, "PRISMPIXELCREATORS.COM", cx, h - (portrait ? 96 : 44) * s, 3 * s);
}

function paint(w, h, seed, dateLabel) {
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  paintLight(ctx, w, h, mulberry32(seed));
  paintWords(ctx, w, h, dateLabel, h > w);
  return new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
}

export async function renderLightCards(seed) {
  const date = new Date(seed);
  const dateLabel = date.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  await Promise.allSettled([
    document.fonts.load('300 58px "Geist Variable"'),
    document.fonts.load('300 24px "Inter"'),
  ]);
  const [portrait, landscape] = await Promise.all([
    paint(1080, 1920, seed, dateLabel),
    paint(1200, 630, seed, dateLabel),
  ]);
  return { portrait, landscape, dateLabel };
}
